

export default {
  data () {
    return {
      scroll_to_top_visible: false,
      showcartmodal: false,
      cartproduct: {}
    }
  },
  head () {
    return this.$nuxtI18nHead({
      addSeoAttributes: true
    })
  },
  created () {
    this.$nuxt.$on('openCart', (value, productData) => {
      this.showCart(value, productData)
    })
    this.$nuxt.$on('closeCart', (value) => {
      this.closeCart(value)
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.$nuxt.$loading.start()
      setTimeout(() => this.$nuxt.$loading.finish(), 3000)
    })
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {
    scrollTop () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
    scrollListener (e) {
      this.scroll_to_top_visible = window.scrollY > 150
    },
    showCart (item, productData) {
      this.showcartmodal = item
      this.cartproduct = productData
    },
    closeCart (item) {
      this.showcartmodal = item
    }
  }
}
